import { combineReducers } from 'redux'
import { combineActions, handleAction, handleActions } from 'redux-actions'

import { share, shareClose, shareSuccess } from './actions'
import defaultState from './defaultState'

export default combineReducers({
  open: handleActions({
    [share]: () => true,
    [combineActions(shareSuccess, shareClose)]: () => false
  }, defaultState.open),
  data: handleAction(share, (state, { payload }) => ({ ...payload }), defaultState.data),
  support: (state = defaultState.support) => state
})
